package com.cs.ejobin.platform

import kotlinx.browser.window

actual fun openExternalUrl(url: String) {
    window.open(url, "_blank")
}